<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='规范管理' label2="新增规范信息" url="/standard/standardlist"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <label class="col-xl-3 col-form-label">模板：</label>
            <div class="col-xl-6">
              <el-select v-model="form.standardid" filterable placeholder="请选择">
                <el-option label="请选择" value=""></el-option>
                <el-option v-for="item in standardOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-3 col-form-label">专业：</label>
            <div class="col-xl-6">
              <el-form-item prop="spid" :rules="{required: true, message: '专业不能为空', trigger: 'blur'}">
                <ZPGLFormDictItemSelect v-bind:val_1="form.spid" v-model="form.spid" :dictid='this.$utils.DictEnum.specialty'></ZPGLFormDictItemSelect>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-3 col-form-label">届别：</label>
            <div class="col-xl-6">
              <el-form-item prop="standardyear" :rules="{required: true, message: '届别不能为空', trigger: 'blur'}">
                <ZPGLFormDictItemSelect v-bind:val_1="form.standardyear" v-model="form.standardyear" :dictid='this.$utils.DictEnum.stuyear'></ZPGLFormDictItemSelect>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-3 col-form-label">规范名称：</label>
            <div class="col-xl-6">
              <el-form-item prop="standardname" :rules="{required: true, message: '规范名称不能为空', trigger: 'blur'}">
                <el-input v-model="form.standardname" placeholder="请输入规范名称"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-3 col-form-label">规范说明：</label>
            <div class="col-xl-6">
              <el-input type="textarea" v-model="form.standardremark"></el-input>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12 m--align-center">
                  <SaveButton :url='saveUrl' back="/standard/standardlist"></SaveButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StandardAdd',
    data() {
      return {
        form: {
          standardname: '',
          spid: '',
          standardyear: '',
          standardremark: '',
          template: '',
          token: ''
        },
        standardOptions: [],
        saveUrl: this.$utils.Url.zpgl + '/api/APIStandard/Add'
      }
    },
    methods: {
      LoadStandard: function() {
        var args = {
          token: this.form.token,
          pageSize: 99999,
          currentPage: 1
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIStandard/List', args, function(data) {
          for (var i = 0; i < data.Data.length; i++) {
            var arg = {
              value: data.Data[i]["StandardID"],
              label: data.Data[i]["StandardName"]
            }
            that.standardOptions.push(arg)
          }
        }, null, null, null)
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.LoadStandard()
    }
  }
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }

  .el-select {
    width: 100%;
  }
</style>
